import { Link } from 'react-router-dom';

import routesPath from '@/shared/constants/routesPath';

import Button from '@/components/ui/button';
import { InputWithLabel } from '@/components/ui/input';
import useLogin from '@/hooks/login/useLogin';
import { useTrackPageView } from '@/services/track';

const Login = () => {
  useTrackPageView();
  const {
    formik,
    signInWithFacebook,
    signInWithApple,
    isLoading,
    isLoginError,
    providersError,
  } = useLogin();
  const { handleSubmit, getFieldProps, errors: formikError, touched } = formik;

  return (
    <div className="flex w-full flex-col max-md:max-w-full">
      <h1 className="text-center md:text-[48px] max-md:max-w-full text-[32px]">
        Login as a Lanetalk Subscriber
      </h1>
      <div className="mt-12 max-md:mt-1 max-md:max-w-full">
        <div className="flex md:justify-between max-md:items-center gap-5 max-md:flex-col max-md:gap-0">
          <form
            className="relative flex w-[66%] max-w-[400px] flex-col max-md:ml-0 max-md:w-full"
            onSubmit={handleSubmit}
          >
            <div className="grid grow gap-4 max-md:mt-10">
              <h2 className="text-xl">Use your Lanetalk account</h2>
              <InputWithLabel
                label="Email"
                placeholder="Email"
                type="email"
                {...getFieldProps('email')}
                error={touched.email && formikError.email}
              />
              <InputWithLabel
                label="Password"
                placeholder="Password"
                type="password"
                className="mt-2"
                {...getFieldProps('password')}
                error={touched.password && formikError.password}
              />
            </div>

            {isLoginError && (
              <div className="absolute bottom-16 text-red-500">
                Invalid email or password. Please try again.
              </div>
            )}

            <div className="mt-6 flex items-center justify-center md:justify-between gap-5 max-md:flex-wrap-reverse">
              <Button variant="link" asChild>
                <Link to={routesPath.FORGOT_PASSWORD}>Forgot password?</Link>
              </Button>
              <Button
                variant="primary"
                size="lg"
                type="submit"
                disabled={isLoading}
                className="max-md:w-full"
              >
                {isLoading ? 'Loading...' : 'Login'}
              </Button>
            </div>
          </form>

          {/* Socials */}
          <div className="ml-5 flex w-[34%] flex-col items-center max-md:ml-0 max-md:w-full">
            <div className="flex flex-col max-md:mt-10">
              <h2 className="text-xl">Use your social account</h2>
              <div className="mt-6 flex gap-4">
                <div id="google-login-button" className="gButton scale-150" />
                <Button
                  onClick={signInWithFacebook}
                  variant="icon"
                  className="size-16 bg-white px-[18px] hover:bg-white active:bg-white"
                >
                  <svg
                    viewBox="38.657999999999994 12.828 207.085 207.085"
                    xmlns="http://www.w3.org/2000/svg"
                    width="64"
                  >
                    <path
                      d="M158.232 219.912v-94.461h31.707l4.747-36.813h-36.454V65.134c0-10.658 2.96-17.922 18.245-17.922l19.494-.009V14.278c-3.373-.447-14.944-1.449-28.406-1.449-28.106 0-47.348 17.155-47.348 48.661v27.149H88.428v36.813h31.788v94.461l38.016-.001z"
                      fill="#3c5a9a"
                    />
                  </svg>
                </Button>
                <Button
                  onClick={signInWithApple}
                  variant="icon"
                  className="size-16 bg-white px-4 hover:bg-white active:bg-white"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="64"
                    viewBox="-1.5 0 20 20"
                  >
                    <path
                      d="M11.57 3.193c.73-.845 1.221-2.022 1.087-3.193-1.05.04-2.322.671-3.075 1.515-.677.749-1.267 1.946-1.108 3.094 1.172.087 2.368-.57 3.097-1.416m2.628 7.432c.03 3.027 2.77 4.034 2.801 4.047-.022.07-.438 1.435-1.444 2.845-.87 1.218-1.774 2.43-3.196 2.457-1.398.025-1.848-.794-3.447-.794-1.597 0-2.097.768-3.42.819-1.373.049-2.42-1.318-3.296-2.532C.403 14.984-.967 10.45.873 7.39c.915-1.52 2.548-2.482 4.321-2.506 1.348-.025 2.621.869 3.445.869.825 0 2.372-1.075 3.998-.917.68.027 2.591.263 3.818 1.984-.1.059-2.28 1.275-2.256 3.805"
                      fill="#000"
                      fillRule="evenodd"
                    />
                  </svg>
                </Button>
              </div>
              {providersError && (
                <div className="mt-4 text-red-500">
                  We could not sign you in. Please try again.
                </div>
              )}
            </div>
          </div>
        </div>
        <p className="mt-12 flex items-center justify-center gap-3.5 text-muted max-md:mt-10">
          Don&apos;t have an account?
          <Button variant="link" asChild>
            <Link
              to={routesPath.REGISTER}
              target="_blank"
              rel="noopener noreferrer"
            >
              Register
            </Link>
          </Button>
        </p>
      </div>
    </div>
  );
};

export default Login;
